import { OnChange } from '@/features/form/types'
import { RefObject, useEffect, useRef } from 'react'

export const useOnChangeRef = (onChange: OnChange): RefObject<OnChange> => {
    const onChangeRef = useRef(onChange)

    useEffect(() => {
        onChangeRef.current = onChange
    }, [onChange])

    return onChangeRef
}
